export const CREATE_LANE = 'CREATE_LANE';
export const UPDATE_LANE = 'UPDATE_LANE';
export const DELETE_LANE = 'DELETE_LANE';
export const ATTACH_TO_LANE = 'ATTACH_TO_LANE';
export const MOVE = 'MOVE';



/** WEBPACK FOOTER **
 ** ./app/constants/LaneActionTypes.js
 **/